"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _contract = require("@/api/cms/contract");

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'ContractAfterInfo',
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      afterInfoList: [],
      loading: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['filePreviewPrefix', 'imgPreviewPrefix'])),
  watch: {
    contract: {
      handler: function handler() {
        this.loadData();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      var contractId = this.contract && this.contract.id;

      if (!contractId) {
        this.afterInfoList = [];
        return;
      }

      this.loading = true;
      (0, _contract.getContractAfterInfo)(contractId).then(function (response) {
        if (response.code === 200) {
          var data = response.data;

          if (data) {
            _this.afterInfoList = Array.isArray(data) ? data : [data];
          } else {
            _this.afterInfoList = [];
          }
        } else {
          _this.afterInfoList = [];
        }
      }).catch(function () {
        _this.afterInfoList = [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    getFileList: function getFileList(str) {
      if (!str) return [];

      try {
        var parsed = JSON.parse(str);
        if (!Array.isArray(parsed)) return [];
        return parsed.map(function (item) {
          if (typeof item === 'string') {
            return JSON.parse(item);
          }

          return item;
        });
      } catch (_unused) {
        return [];
      }
    },
    getPreviewList: function getPreviewList(str) {
      var _this2 = this;

      return this.getFileList(str).map(function (f) {
        return _this2.getFileUrl(f);
      });
    },
    getFileUrl: function getFileUrl(file) {
      if (file.url) return file.url;
      var prefix = file.type === '图片' ? this.imgPreviewPrefix : this.filePreviewPrefix;
      return (prefix || '') + file.realName;
    }
  }
};
exports.default = _default2;